'use strict';
// this file was created to prevent NativeReanimated from being included in the web bundle
import { createJSReanimatedModule } from './js-reanimated';

export const ReanimatedModule = createJSReanimatedModule();
